import React, { Component } from 'react';
import * as Constants from '../../common/Global/constants';
import { matchPath,withRouter } from 'react-router-dom';
import { getThemeSettingsVariables, hasFeatureAccess, isEmptyVariable } from '../../common/Global/commonFunctions';
import {TopTabsLayout} from '../../common/Global/globalStyles.style';

let themeSettings  = getThemeSettingsVariables();
let themeColor='';
let isTask ='';
let isExecuteTask ='';
let isObservation =''
let isGeneral =''
let isFollowUp =''
let isAuditeeComment = '';
class ClientsTopMenu extends Component{
    constructor(props) {
        super(props);

        themeSettings  = getThemeSettingsVariables();
        themeColor = `rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},${themeSettings.themeColor.a})`;
        isTask = this.checkActivePath(["/tasktemplates","/edittasktemplate","/tasktemplatedetails"]);
        isExecuteTask = this.checkActivePath([ "/executetasktemplates","/addexectasktemplate","/editexectasktemplate","/exectasktemplatedetails"]);
        isObservation = this.checkActivePath([ "/observationtemplates", "/addobservationtemplate","/editobservationtemplate","/observationtemplatedetails" ]);
        isGeneral = this.checkActivePath([ "/generaltemplates", "/editgeneraltemplates","/generaltemplatesdetails","/addgeneraltemplates"]);
        isFollowUp = this.checkActivePath([ "/followuptemplates","/editfollowuptemplate","/followuptemplatedetails","/addfollowuptemplate" ]);
        isAuditeeComment = this.checkActivePath([ "/auditeecommenttemplates", "/editauditeecommenttemplates","/auditeecommenttemplatesDetails","/addauditeecommenttemplates" ]);
    }

    checkActivePath = (path) => {
        themeSettings = getThemeSettingsVariables();
        themeColor = `rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},${themeSettings.themeColor.a})`;
        return matchPath(this.props.history.location.pathname, { path });
    }

    usersOnClick = () => {
        this.props.usersTabItemOnClick(this.props.clientId)
    }

    clientsOnClick = () => {
        this.props.history.push(Constants.URL_CLIENTS);
    }

    handleOnClick = (pathname) => {
        const {clientId,departmentList} = this.props;
        this.props.history.push({
            pathname,
            state: {
                clientId,
                departmentList
            }
        })
        window.location.reload()
    }

    render(){
        const {clientId,displayingClientUsers,displayingClients,displayingTemplates,showInfo} = this.props;
        let width="12.5%";
        if(!isEmptyVariable(clientId)){
            width = "25%";
        }
        if(displayingTemplates){
            width = `${12.5 * 7}%`;
        }
         
        return(
            <TopTabsLayout themeSettings={this.props.themeSettings}>
            
                <div className="question-tabs"  style={{marginRight:0, display:'inline-flex', alignItems:'center'}}>
                    <ul style={{width:width}}>

                    {/* By default Clients must be displayed. if users tab is there then we need to
                    display both the tabls */}
                    <li className={displayingClients?"questiontab-active":""}>
                        <a onClick={this.clientsOnClick} href=""
                            style={{color: !displayingClients ? themeColor : '', fontWeight: !displayingClients ? "bold" : "100px"}}>Clients</a>
                    </li>
                    {
                        !isEmptyVariable(clientId) && displayingClientUsers &&
                        <li className={displayingClientUsers?"questiontab-active":""}>
                            <a onClick={this.usersOnClick} href="javascript:void(0)"
                            style={{color: !displayingClientUsers ? themeColor : '', fontWeight: !displayingClientUsers ? "bold" : "100px"}}>Users</a>
                        </li>
                    }
                    {
                        displayingTemplates &&
                        <>
                            <li className={ isTask ? "questiontab-active" : "" }
                                onClick={()=>this.handleOnClick(Constants.URL_TASK_TEMPLATES)}
                            >
                                <a href="javascript:void(0);"
                                style={{color: !isTask ? themeColor : '', fontWeight: !isTask ? "bold" : "100px"}}>
                                    Task
                                </a>
                            </li>
                            <li className={ isExecuteTask ? "questiontab-active" : "" }
                                onClick={()=>this.handleOnClick(Constants.URL_EXECUTE_TASK_TEMPLATES)}
                            >
                                <a href="javascript:void(0);"
                                style={{color: !isExecuteTask ? themeColor : '', fontWeight: !isExecuteTask ? "bold" : "100px"}}>
                                    Execute Task
                                </a>
                            </li>
                            {hasFeatureAccess(Constants.FEATURE_OBSERVATION) &&
                            <li className={ isObservation ? "questiontab-active" : "" }
                                onClick={()=>this.handleOnClick(Constants.URL_OBSERVATION_TEMPLATES)}
                            >
                                <a href="javascript:void(0);"
                                style={{color: !isObservation ? themeColor : '', fontWeight: !isObservation ? "bold" : "100px"}}>
                                    Observation
                                </a>
                            </li>
                            }
                            {hasFeatureAccess(Constants.FEATURE_GENERAL) &&
                                <li className={ isGeneral ? "questiontab-active" : "" }
                                    onClick={()=>this.handleOnClick(Constants.URL_GENERAL_TEMPLATES)}
                                >
                                    <a href="javascript:void(0);"
                                    style={{color: !isGeneral ? themeColor : '', fontWeight: !isGeneral ? "bold" : "100px"}}>  
                                        General
                                    </a>
                                </li>
                            }
                            <li className={ isFollowUp ? "questiontab-active" : "" }
                                 onClick={()=>this.handleOnClick(Constants.URL_FOLLOWUP_TEMPLATES)}
                             >
                                <a href="javascript:void(0);"
                                style={{color: !isFollowUp ? themeColor : '', fontWeight: !isFollowUp ? "bold" : "100px"}}>
                                    Follow Up
                                </a>
                            </li>
                            <li className={ isAuditeeComment ? "questiontab-active" : "" }
                                onClick={()=>this.handleOnClick(Constants.URL_AUDITEE_COMMENT_TEMPLATES)}
                            >
                                <a href="javascript:void(0);"
                                style={{color: !isAuditeeComment ? themeColor : '', fontWeight: !isAuditeeComment ? "bold" : "100px"}}>
                                    Response
                                </a>
                            </li>
                        </>
                    }
                    </ul>
                    {
                        this.props?.companyName &&
                        // <div className="topbar-company-name">
                            <span style={{marginLeft:150, fontWeight:500}}>{this.props?.companyName}</span>
                        // </div>
                    }
                </div>
                {!displayingTemplates && showInfo &&
                <div onClick={this.props.toggleCardsDisplay}
                style={{opacity:this.props.hideInfo?"0":"1"}} className="infocard-showhide-col">
                    <div className="infocard-icon-col">
                        <img src="/assets/images/topbar-info.svg" />
                    </div>
                </div>
                }
            </TopTabsLayout>
        )
    }
}

export default withRouter(ClientsTopMenu);